{
	"default": {
		"logout": "Sair",
		"changeLanguage": "Alterar idioma",
		"changeSystemLanguage": "Alterar idioma do sistema",
		"changeLayout": "Alterar layout"
	},
	"selectLanguageModal": {
		"selectLanguage": "Selecione o idioma",
		"cancel": "Canelar",
		"confirm": "Confirmar"
	},
	"org": {
		"panel": "Locais",
		"employee": "Acessos da equipe",
		"crm": "CRM",
		"categories": "Categorias",
		"reports": "Relatórios",
		"recharge": "Recarga",
		"stock": "Estoque",
		"giftback": "Giftback",
		"giftCard": "Gift Card",
		"fiscal": "Fiscal",
		"internalSalesCampaign": "Campanha de vendas",
		"taxRegistration": "Cadastro fiscal",
		"productRegistration": "Cadastro base de produto",
		"clientArea": "Hub de Dados",
		"customersList": "Lista de Clientes",
		"stockInventory": "Cadastro Base de Produtos",
		"taxData": "Dados Fiscais",
		"fiscalSettings": "Dados Fiscais",
		"financialReport": "Relatório geral",
		"satisfactionSurvey": "Pesquisa de Satisfação",
		"customers": "Área do Cliente",
		"sendingMessages": "Envio de Mensagens",
		"loyalty": "Fidelização",
		"communication": "Campanhas",
		"chartOfAccounts": "Plano de Contas",
		"vendors": "Vendor",
		"team": "Equipe",
		"integrations": "Integrações",
		"settings": "Configurações",
		"messagesAnalytics": "Relatório de mensagens",
		"catering": "Catering"
	},
	"place": {
		"events": "Eventos",
		"businessInteligence": "Business Intelligence",
		"pdvTeam": "Operadores de PDV",
		"products": "Produtos",
		"opened": "Em aberto",
		"clientArea": "Hub de Dados",
		"closed": "Em aberto",
		"crm": "CRM",
		"reports": "Relatórios",
		"preChargeLabel": "Pré-carga",
		"inventoryControl": "Controle de Estoque",
		"receptive": "Receptivo",
		"productAndMenu": "Produtos & Cardápios",
		"menu": "Cardápio",
		"bars": "Bares e Setores",
		"clients": "Clientes",
		"tagGroups": "Grupo de Tags",
		"reserve": "Fila de espera",
		"reserveV2": "Gestão de reservas",
		"tickets": "Entradas",
		"guestList": "Lista de Convidados",
		"financialReport": "Relatórios Financeiros",
		"barReports": "Relatórios de Bar",
		"salesReport": "Relatórios de vendas",
		"tableReports": "Relatórios de Mesa",
		"prechargeReports": "Pré-Carga por planilha",
		"ticketsReport": "Relatórios de Bilheteria",
		"storage": "Estoque",
		"storageReports": "Relatórios de Estoque",
		"extract": "Extrato",
		"invoices": "Fiscal",
		"promotions": "Bônus, Promoções e Descontos",
		"pos": "Vendas POS",
		"cashFlow": "Financeiro",
		"zigAccount": "Zig Conta",
		"delivery": "Delivery",
		"deliveryOrders": "Pedidos",
		"deliveryReport": "Relatórios",
		"deliveryMenus": "Cardápios",
		"deliveryOrdersManager": "Gestor de pedidos",
		"deliveryIntegrations": "Integrações",
		"deliverySettings": "Configurações",
		"transferReport": "Relatório de Repasses",
		"multivendor": "Multi-vendor",
		"precharge": "Sites de Pré-Carga",
		"whatsup": "Qual é a Boa?",
		"passwordCard": "Cartão de senhas",
		"audits": "Auditoria",
		"settings": "Configurações",
		"contracts": "Contratos",
		"placeData": "Informações de contrato",
		"rechargeManagement": "Gestão de Saldo",
		"financialFile": "Arquivo Financeiro",
		"generalConfig": "Configuração Geral",
		"operationReport": "Relatório de Operação",
		"config": "Configurações",
		"kds": "Gestor de pedidos (KDS)",
		"tableMap": "Mapa de mesas",
		"tableMapAttendanceManagement": "Gestão de atendimento",
		"kdsConfig": "Gerenciar KDS",
		"kdsReport": "Relatório de produção",
		"hawkersReport": "Lista de Transações de Ambulantes",
		"catering": "Catering",
		"wizardSummary": "Resumo Wizard",
		"paymentLinks": "Links de pagamento"
	},
	"event": {
		"panel": "Painel",
		"businessIntelligence": "Painel Geral",
		"eventPanel": "Painel do evento",
		"reports": "Relatórios",
		"clientArea": "Hub de Dados",
		"customers": "Clientes",
		"conference": "Conferência de evento",
		"clients": "Informações de Clientes",
		"guestList": "Listas de Convidados",
		"financialReport": "Relatórios Financeiros",
		"barReports": "Relatórios de Bar",
		"salesReport": "Relatórios de vendas",
		"tableReports": "Relatórios de Mesa",
		"ticketsReport": "Relatórios de Bilheteria",
		"sellChip": "Vendas sem cartão",
		"bookings": "Pacotes",
		"devices": "Dispositivos",
		"multivendor": "Multi-vendor",
		"zigTag": "Zig Tag",
		"operationReport": "Relatório de Operação",
		"hawkersReport": "Relatório de Ambulantes",
		"rechargeManagement": "Gestão de Saldo"
	}
}
